import { render, staticRenderFns } from "./PosttypeFilter.vue?vue&type=template&id=17e98f83&"
import script from "./PosttypeFilter.vue?vue&type=script&lang=js&"
export * from "./PosttypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports